import { unMask } from 'utils/mask';
import { CidadeProps } from './personProps';
import { map } from 'lodash';
import { FormPropsPJType } from './types/FormPropType/FormPropPJType';

export function findEnderecoIndex(enderecoArray: any) {
  if (enderecoArray === undefined) return -1;
  let index = -1;
  let type = 5;
  //type = 5 not found
  //type = 4 Contato
  //type = 3 Entrega
  //type = 2 Comercial
  //type = 1 Residencial
  //type = 0 Cobrança
  enderecoArray.forEach((ref: any, ind: number) => {
    if (type > 0 && ref.cobranca) {
      index = ind;
      type = 0;
    } else if (type > 1 && ref.residencial) {
      index = ind;
      type = 1;
    } else if (type > 2 && ref.comercial) {
      index = ind;
      type = 2;
    } else if (type > 3 && ref.entrega) {
      index = ind;
      type = 3;
    } else if (type > 4 && ref.contato) {
      index = ind;
      type = 4;
    }
  });
  return index;
}

export default function convertPJDataToSubmit(
  person: any,
  formValues: FormPropsPJType,
  // estadoCivilSelected: EstadoCivilProps,
  // profissaoSelected: ProfissaoProps,
  // comprovanteSelected: ProfissaoProps,
  cidadeSelected: CidadeProps
  // municipioEmpId?: number
) {
  let allEmails: any[] = [];
  if (person && person.emails && person.emails.length > 0) {
    if (
      person.emails.findIndex((val: any) => {
        val.email === formValues.email;
      }) === -1
    ) {
      allEmails = [
        ...person.emails,
        {
          email: formValues.email,
          preferencia: true,
          status: 1,
        },
      ];
    }
  } else {
    allEmails = [
      {
        email: formValues.email,
        preferencia: true,
        status: 1,
      },
    ];
  }

  allEmails = allEmails.map((item: any) =>
    item.email === formValues.email
      ? { ...item, preferencia: true, status: 1 }
      : { ...item, status: 2 }
  );

  let allTelefones: any[] = [];
  if (person && person.telefones && person.telefones.length > 0) {
    if (
      person.telefones.findIndex(
        (item: any) => item.status === 1 && item.preferencia === true
      ) < 0
    ) {
      allTelefones = [
        {
          ddd: formValues.telefone.substring(0, 2),
          preferencia: true,
          status: 1,
          telefone: formValues.telefone.substring(2, 11),
          tipo: null,
        },
      ];
    } else {
      allTelefones = person.telefones.map((item: any) =>
        item.status === 1 && item.preferencia === true
          ? {
              ...item,
              ddd: formValues.telefone.substring(0, 2),
              telefone: formValues.telefone.substring(2, 11),
            }
          : item
      );
    }
  } else {
    allTelefones = [
      {
        ddd: formValues.telefone.substring(0, 2),
        preferencia: true,
        status: 1,
        telefone: formValues.telefone.substring(2, 11),
        tipo: null,
      },
    ];
  }

  let allEnderecos: any[] = [];
  if (person && person.enderecos && person.enderecos.length > 0) {
    allEnderecos = person.enderecos;

    const index = findEnderecoIndex(allEnderecos);
    if (index === -1) {
      allEnderecos = [
        ...allEnderecos,
        {
          enderecoId: null,
          residencial: true,
          cobranca: true,
          comercial: false,
          entrega: false,
          contato: false,
          endereco: formValues.logradouro,
          numero: Number(formValues.numero),
          complemento: formValues.complemento ?? null,
          bairro: formValues.bairro,
          cep: Number(formValues.cep),
          tipoMoradia: null,
          tipoLogradouro: formValues.tipoLogradouro,
          resideDesdeMesAno: null,
          codigoEstado: cidadeSelected.codigoEstado,
          nomeMunicipio: cidadeSelected.descricao,
          tipoMoradiaDescricao: null,
          tipoLogradouroDescricao: null,
        },
      ];
    } else {
      allEnderecos = allEnderecos.map((ref: any, ind: any) => {
        if (index === ind) {
          return {
            enderecoId: person?.enderecos[index].enderecoId,
            residencial: person?.enderecos[index].residencial,
            cobranca: true,
            comercial: person?.enderecos[index].comercial,
            entrega: person?.enderecos[index].entrega,
            contato: person?.enderecos[index].contato,
            endereco: formValues.logradouro,
            numero: Number(formValues.numero),
            complemento: formValues.complemento ? formValues.complemento : null,
            bairro: formValues.bairro,
            cep: Number(formValues.cep),
            tipoMoradia: person?.enderecos[index].tipoMoradia,
            tipoLogradouro: formValues.tipoLogradouro,
            resideDesdeMesAno: person?.enderecos[index].resideDesdeMesAno,
            codigoEstado: cidadeSelected.codigoEstado,
            nomeMunicipio: cidadeSelected.descricao,
            tipoMoradiaDescricao: person?.enderecos[index].tipoMoradiaDescricao,
            tipoLogradouroDescricao:
              person?.enderecos[index].tipoLogradouroDescricao,
          };
        }

        return ref;
      });
    }
  } else {
    allEnderecos = [
      {
        enderecoId: null,
        residencial: true,
        cobranca: true,
        comercial: false,
        entrega: false,
        contato: false,
        endereco: formValues.logradouro,
        numero: Number(formValues.numero),
        complemento: formValues.complemento ? formValues.complemento : null,
        bairro: formValues.bairro,
        cep: Number(formValues.cep),
        tipoMoradia: null,
        tipoLogradouro: formValues.tipoLogradouro,
        resideDesdeMesAno: null,
        codigoEstado: cidadeSelected.codigoEstado,
        nomeMunicipio: cidadeSelected.descricao,
        tipoMoradiaDescricao: null,
        tipoLogradouroDescricao: null,
      },
    ];
  }

  const personData = {
    ...person,
    nomeFantasia: formValues.nomeFantasia,
    cnpj: unMask(formValues.cnpj, '[^0-9A-Za-z]').toUpperCase(),
    dataFundacaoEmpresa: formValues.dataFundacaoEmpresa,
    inscricaoEstadual: formValues.inscricaoEstadual,
    observacao: formValues.observacoes,
    emails: allEmails,
    telefones: allTelefones,
    enderecos: allEnderecos,
    dadosFinanceira: {
      pessoaId: person?.id,
      porteEmpresa: Number(formValues.porteEmpresa),
      cnae: formValues.cnae,
      dataFaturamento: undefined,
      valorFaturamento:
        Number(unMask(formValues.faturamentoAnual ?? '', '[^0-9]')) / 100,
      valorCapitalSocial: undefined,
      nirf: undefined,
      classeEconomicaSetor: Number(formValues.classeEconomica),
      ramoAtividade: formValues.ramoAtividade,
    },
    tipoEmpresa: Number(formValues.tipoEmpresa),
    socios: map(formValues.socios, (socio) => ({
      pessoaId: person.id,
      pessoaSocioId: socio.pessoaSocioId,
      cpfCnpj: socio.cpfCnpj,
      nome: socio.nome,
      percentualSocietario: socio.percentualSocietario,
      parcentualSocietario: socio.percentualSocietario,
    })),
    avalista: formValues.avalista
      ? [
          {
            codPessoaAvalista: formValues.avalista.id,
            codPessoa: formValues.id,
            statusRegistro: 1,
            cpfCnpjAvalista: Number.parseInt(
              unMask(formValues.avalista.cpf, '\\.|-')
            ),
            nomeAvalista: formValues.avalista.nome,
          },
        ]
      : person.id === formValues.id
      ? person.avalista
      : undefined,
    versaoApi: 3, // Versão para permitir salvar o avalista
  };

  return personData;
}
